import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { t } from '@sm/intl';
import { Box } from '@wds/box';
import { Typography } from '@wds/typography';
const COPY = {
  CityInputLabel: {
    id: 'buildWithAI.AnswersAddress.CityInputLabel',
    defaultMessage: '[City]',
    description: '[Type: Label][Vis.: high] - Label for city address input'
  },
  CountryInputLabel: {
    id: 'buildWithAI.AnswersAddress.CountryInputLabel',
    defaultMessage: '[Country]',
    description: '[Type: Label][Vis.: high] - Label for country address input'
  },
  StateInputLabel: {
    id: 'buildWithAI.AnswersAddress.StateInputLabel',
    defaultMessage: '[State]',
    description: '[Type: Label][Vis.: high] - Label for state address input'
  },
  StreetAddressInputLabel: {
    id: 'buildWithAI.AnswersAddress.StreetAddressInputLabel',
    defaultMessage: '[Street address]',
    description: '[Type: Label][Vis.: high] - Label for street address input'
  }
};
const AddressItemText = ({
  children
}) => _jsx(Typography, {
  component: "div",
  color: "darkMuted",
  variant: "body",
  children: children
});
/**
 * Answer options for an Address question.
 * Just shows address individual question information.
 */
const AnswersAddress = () => _jsxs(Box, {
  children: [_jsx(AddressItemText, {
    children: t(COPY.StreetAddressInputLabel)
  }), _jsx(AddressItemText, {
    children: t(COPY.CityInputLabel)
  }), _jsx(AddressItemText, {
    children: t(COPY.StateInputLabel)
  }), _jsx(AddressItemText, {
    children: t(COPY.CountryInputLabel)
  })]
});
export default AnswersAddress;